<template>
    <div class="calendar-popup">
        <span class="month-pre" @click="handlePreMonth"></span>
        <span class="month-next" @click="handleNextMonth"></span>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "CalendarPopup",
    props: ["value"],
    data() {
        return {};
    },
    methods: {
        handlePreMonth() {
            this.$emit("monthSwitch", "pre");
        },
        handleNextMonth() {
            this.$emit("monthSwitch", "next");
        }
    }
};
</script>

<style lang="less" scoped>
.calendar-popup {
    position: absolute;
    top: 48px;
    right: 0;
    display: inline-flex;
    flex-direction: row;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    background: #fff;
    min-height: 60px;
    min-width: 150px;
    z-index: 2;

    .month-pre,
    .month-next {
        position: absolute;
        top: 12px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        background: #fff;
        cursor: pointer;

        &:hover {
            background: #dee9f2;

            &:before {
                background-position: -178px -21px;
            }
        }
    }

    .month-pre {
        left: 20px;
    }

    .month-next {
        right: 20px;
    }

    .month-pre:before,
    .month-next:before {
        width: 9px;
        height: 13px;
        content: "";
        display: inline-block;
        background: url("@{zhijiStaticImagePath}class-spr.png") no-repeat;
        background-position: -168px -21px;
        vertical-align: -2px;
    }

    .month-pre:before {
        transform: rotate(180deg);
    }

    .month-next:before {
        transform: rotate(1turn);
    }
}
</style>
